import { render, staticRenderFns } from "./BaseApp.vue?vue&type=template&id=6521c3ca"
import script from "./BaseApp.vue?vue&type=script&lang=ts"
export * from "./BaseApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports